

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { FaultsApi, Fault } from '@/api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		vSelect,
		Toast,
	},
	validations: {
		form: {
			log: {},
		},
	},
	mixins: [validationMixin],
})
export default class AddFault extends Vue {
	public form = {
		type: '',
		log: '',
	};
	public errors = [];
	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	@Prop(Number)
	public productId!: number;
	@Prop(String)
	public faultStatus!: string;

	public faultOptions = [
		{ text: '48 Power Outage', value: '48PowerOutage' },
		{ text: 'Bad Sensor Data', value: 'BadSensorData' },
		{ text: 'Bad Sensor Reading', value: 'BadSensorReading' },
		{ text: 'Battery Low', value: 'BatteryLow' },
		{ text: 'Cell Strength', value: 'CellStrength' },
		{ text: 'Certificate', value: 'Certificate' },
		{ text: 'Dirty Lidar', value: 'DirtyLidar' },
		{ text: 'Invalid Bootloader', value: 'InvalidBootloader' },
		{ text: 'Invalid Vat Setup', value: 'InvalidVatsetup' },
		{ text: 'Missing Sensor Data', value: 'MissingSensorData' },
		{ text: 'Missing Transceiver Data', value: 'MissingTransceiverData' },
		{ text: 'Missing Transceiver Events', value: 'MissingTransceiverEvents' },
		{ text: 'Multiple Reboots', value: 'MultipleReboots' },
		{ text: 'Possible Dry Off', value: 'PossibleDryOff' },
		{ text: 'Power Outage', value: 'PowerOutage' },
		{ text: 'Reverted Firmware', value: 'RevertedFirmware' },
		{ text: 'Sensor Allocation', value: 'SensorAllocation' },
		{ text: 'Widespread Outage', value: 'WidespreadOutage' },
		{ text: 'Site Inspection', value: 'SiteInspection' },
	];

	constructor() {
		super();
	}

	public clearFault() {
		this.form = {
			type: '',
			log: '',
		};
		this.$v.$reset();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';
		const fault: Fault = this.form;
		fault.ownerType = 'products';
		fault.ownerId = this.productId;
		fault.name = this.form.type;
		fault.message = this.form.log;
		try {
			const response = await new FaultsApi().addFault({ data: fault });
			this.$emit('newFault', response.data.data);
		} catch (e) {
			const error = e.response.data;
			new Toast().makeToast(error, 'Error Creating Fault', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('New Fault Created', 'fault Created', 'success');
		this.submitStatus = 'OK';
		this.$bvModal.hide('faultModal');
		this.clearFault();
		this.$v.$reset();
	}
}
